import React from "react";
const MessagePageContext = React.createContext();
export default MessagePageContext;
